import { ConvertSizeChartResponseData } from "schema"
import { z } from "zod"

type ConvertSizeChartResult = z.infer<typeof ConvertSizeChartResponseData>
type SizeChartResult = ConvertSizeChartResult["result"]

const INCHES_CONVERSION_FACTOR = 0.39

function parseNumericValue(value: string) {
  const normalizedValue = value.trim().replace(",", ".")
  if (!/^-?\d+(\.\d+)?$/.test(normalizedValue)) return null

  const parsedValue = Number(normalizedValue)
  return Number.isFinite(parsedValue) ? parsedValue : null
}

function formatNumber(value: number) {
  return Number(value.toFixed(2)).toString()
}

export function getInchesValue(value: string) {
  const parsedValue = parseNumericValue(value)
  if (parsedValue === null) return null

  return formatNumber(parsedValue * INCHES_CONVERSION_FACTOR)
}

function formatSizeChartValueWithInches(value: string) {
  const inchesValue = getInchesValue(value)
  if (inchesValue === null) return value

  return `${value} / ${inchesValue}`
}

export function getMetafieldSizeChartResult(result: SizeChartResult) {
  if (!result.convertToInches) return result

  return {
    ...result,
    sizes: result.sizes.map((size) => ({
      ...size,
      values: size.values.map(formatSizeChartValueWithInches),
    })),
  }
}
